
import { mapState, mapMutations } from 'vuex'
import BlogTextColor from '~/components/Common/Blog/BlogTextColor'
export default {
    components: {
        BlogTextColor,
    },
    created() {
        this.SET_ISEARNING(true)
    },
    beforeDestroy() {
        this.SET_ISEARNING(false)
    },
    methods: {
        ...mapMutations('board', ['SET_ISEARNING',]),
    },
}
